import PropTypes from "prop-types";

// Small inline SVG icons for the tutorial slides (no icon dependency).

// Hollow 'unchecked' rounded square (square = multiple items can be selected)
export const EmptyBoxIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="5"
      fill="none"
      stroke={color}
      strokeWidth={2}
    />
  </svg>
);
EmptyBoxIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

// Filled rounded square with a check cut through it — marks a completed checklist item.
export const CheckBoxIcon = ({
  size = 24,
  color = "currentColor",
  checkColor = "#fff",
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="2" y="2" width="20" height="20" rx="6" fill={color} />
    <path
      d="M7.5 12.3 L10.6 15.4 L16.5 9.2"
      fill="none"
      stroke={checkColor}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
CheckBoxIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  checkColor: PropTypes.string,
};
